module.exports = __webpack_public_path__ + "img/minion_render_thumb.db4f6493.jpg";